import { render, staticRenderFns } from "./PriceBadge.vue?vue&type=template&id=cdb51660&scoped=true&"
import script from "./PriceBadge.vue?vue&type=script&lang=js&"
export * from "./PriceBadge.vue?vue&type=script&lang=js&"
import style0 from "./PriceBadge.vue?vue&type=style&index=0&id=cdb51660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb51660",
  null
  
)

export default component.exports